<!-- 富信只允许单个上传 -->
<template>
  <div>
    <div class="flex">
      <el-upload
        class="upload"
        :action="'/jd-yusms/sms/upload/media-file/' + type"
        :accept="acceptStr"
        :before-upload="beforeUpload"
        :on-success="handleUpload"
        :on-error="handleError"
        :on-remove="handleRemove"
        :file-list="fileList"
        :disabled="disabled"
      >
        <div class="flex">
          <el-button type="primary" plain size="small"
            ><img src="@/assets/images/上传.png" />上传文件</el-button
          >
          <slot name="custom"></slot>
        </div>
        <div slot="tip" class="upload_tip">
          只能上传jpg/png/zip文件，且不超过1.4M
        </div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import { mediaFileUpload } from "@/api/smsSend";
export default {
  model: {
    prop: "fileObj",
    event: "changeFile",
  },
  props: {
    size: {
      type: Number,
      default: 1.4,
    },
    // 文件类型
    sorts: {
      type: Array,
      default: function () {
        return [".png", ".jpg", ".jpeg", ".zip"];
      },
    },
    // 文件对象
    fileObj: {
      type: Object,
      default: () => {
        return { name: "", url: "" };
      },
    },
    // 文件类型：10 营业执照 11 签名授权书 12 会员证明 13 信息安全责任书 14 其他证明 20 媒体消息图片 21 媒体消息音频 22 视频
    type: {
      default: 10,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    acceptStr() {
      return this.sorts.join(",");
    },
    // fileList() {
    //   if (this.fileUrl) {
    //     return [{ name:this.fileName, url: this.fileUrl }];
    //   } else {
    //     return [];
    //   }
    // },
    fileList() {
      if (this.fileObj.url) {
        // console.log(this.fileObj);
        return [{ name: this.fileObj.name, url: this.fileObj.url }];
      } else {
        return [];
      }
    },
  },
  methods: {
    beforeUpload(file) {
      console.log(file);
      if (file.size > this.size * 1024 * 1024) {
        this.$message.info(
          "所选文件大小不得超过" + this.size + "M，请重新选择"
        );
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      console.log(type, this.sorts.indexOf(type));
      if (this.sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
      // let forms = new FormData();
      // forms.append("file", file);
      // mediaFileUpload(this.type, forms).then((res) => {
      //   this.$message.success("上传成功");
      //   let { mulitiFileName, fileUrl } = res.data;
      //   this.$emit("changeFile", { name: mulitiFileName, url: fileUrl });
      //   this.$emit("success", res.data);
      // });
      // return false;
    },

    // 上传成功
    handleUpload(res, file, fileList) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.$message.success("上传成功");
        let { mulitiFileName, fileUrl } = res.data;
        this.$emit("changeFile", { name: mulitiFileName, url: fileUrl });
        this.$emit("success", res.data);
      }
    },
    // 上传失败
    handleError(err) {
      console.log(err);
      this.$message.error("上传失败");
    },

    // 移除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        // let fileObj = fileList[0]
        // this.$emit("changeFile", { name: fileObj.name, url: fileObj.url });
        // this.$emit("success", {});
      } else {
        this.$emit("changeFile", { name: "", url: "" });
        this.$emit("success", {});
      }
    },

    // 后面这些暂时不需要
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-upload-list__item {
  transition: none !important;
}

.flex {
  display: flex;
  align-items: center;
}
/deep/.upload_tip {
  margin: 8px 0;
  color: #999999;
  line-height: 12px;
  font-size: 12px;
}

.upload {
  // margin-bottom: 10px;
  display: inline-block;

  .el-button {
    background-color: #fff6f6 !important;
    border: 1px solid #fe4d45 !important;
    color: #fe4d45 !important;

    &:hover {
      background-color: #ffe5e5 !important;
    }

    &:active {
      background-color: #fff4f4 !important;
    }
  }

  img {
    width: 15px;
    margin-right: 2px;
    position: relative;
    top: 2px;
  }
}
</style>
